import { Controller } from "@hotwired/stimulus";

// Explicitly renders the Cloudflare Turnstile widget so it works across Turbo
// Drive navigations (including cached back-navigation). Load the API with
// ?render=explicit so it does not auto-scan the page.
export default class extends Controller {
  static values = { sitekey: String };

  connect() {
    this.waitForTurnstile().then(() => this.render());
  }

  disconnect() {
    if (this.widgetId && window.turnstile) window.turnstile.remove(this.widgetId);
  }

  render() {
    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.sitekeyValue,
      size: "flexible",
    });
  }

  waitForTurnstile() {
    return new Promise((resolve) => {
      const check = () => (window.turnstile ? resolve() : setTimeout(check, 50));
      check();
    });
  }
}
